import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShareWeeklyConsolFormComponent } from './share-weekly-consol-form/share-weekly-consol-form.component';

const routes: Routes = [
  {
    path: '',
    data: {
      title: "Share Consol Planning"
    },
    component: ShareWeeklyConsolFormComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShareWeeklyConsolPlanningRoutingModule { }
